module.exports = __webpack_public_path__ + "static/media/paraicon5.9c40ebdc.webp";